import React, { Component, PropTypes } from 'react';

import css from './slider.scss';

import CornerLabel from '../../block/cornerLabel';
import Carousel from '../../carousel/carousel';

import Case from '../../case/caseElementMenu';
import Editorial from '../../editorial/editorialElement';

import {
	TYPE_EDITORIAL_LIST,
} from '../../../constants/types';

export default class GlobalNavSlider extends Component {
	static propTypes = {
		context: PropTypes.string,
		caseActions: PropTypes.object.isRequired,
		editorialActions: PropTypes.object.isRequired,
		cases: PropTypes.object.isRequired,
		editorials: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired,
		menuActions: PropTypes.object.isRequired,
		menuActive: PropTypes.bool.isRequired,
	};
	static defaultProps = {
		context: '',
		cases: {},
	};

	constructor() {
		super();

		this.forceCompUpdate = true;

		this.state = {
			head: '',
			content: [],
		};
	}

	componentWillMount() {
		// if (!this.props.cases.isFetching && this.props.cases.winners.length < 1) {
		// 	this.props.caseActions.fetchWinners(0, 3);
		// }

		if (!this.props.editorials.isFetching && this.props.editorials.editorials.length < 1) {
			this.props.editorialActions.fetchEditorials(0, 3);
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		// only re-render if context has changed
		return !!(
			nextProps.context !== this.props.context ||
			nextProps.menuActive !== this.props.menuActive ||
			this.forceCompUpdate
		);
	}

	componentWillReceiveProps(nextProps) {}

	render() {
		return (
			<div className='global-nav__context'>
				<div className='global-nav__context__head'>
					<CornerLabel name={this.getHead()} />
				</div>

				<Carousel autoplay={this.props.menuActive}>
					{this.getSlideContent()}
				</Carousel>
			</div>
		);
	}

	shouldAutoplay() {
		return !!this.props.menuActive;
	}

	getHead() {
		switch (this.props.context) {
			case TYPE_EDITORIAL_LIST:
				return 'Featured editorial';
			default:
				return 'Recent winners';
		}
	}

	getSlideContent(props) {
		switch (this.props.context) {
			case TYPE_EDITORIAL_LIST:
				return this.getEditorialComponent(props);
			default:
				return this.getCaseComponent(props);
		}
	}

	getCaseComponent(props) {
		let content = [];

		if (this.props.cases.winners.length) {
			content = this.props.cases.winners.slice(0, 3).map((item, i) => {
				return (<Case key={i} browser={this.props.browser} {...item} menuActions={this.props.menuActions} menuActive={this.props.menuActive} />);
			});
		}

		this.forceCompUpdate = !content.length;

		return content;
	}

	getEditorialComponent(props) {
		let content = [];

		if (this.props.editorials.editorials.length) {
			content = this.props.editorials.editorials.slice(0, 3).map((item, i) => {
				return (<Editorial key={i} {...item} menuActions={this.props.menuActions} menuActive={this.props.menuActive} />);
			});
		}

		this.forceCompUpdate = !content.length;

		return content;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/globalNav/slider/slider.js
 **/